import { Box, Button, CircularProgress } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../redux/reducers/rootReducer";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { uiCloseModalDelete } from "../../../redux/actions/uiActions";
import clsx from "clsx";
import { useStyles } from "../../../shared/styles/useStyles";
import {
  setDeleteUser,
  userCleanActive,
  ValdiateDeleteUser,
} from "../../../module/admin/redux/actions/usersActions";
import { IValidateUser } from "../../../module/admin/form/IValidateUser";

export const FormDeleteUser = () => {
  const { activeUser, DeleteValidation } = useSelector(
    (state: AppState) => state.users
  );
  const user: any = activeUser;
  const dispatch = useDispatch();
  const classes = useStyles();
  const [loading, setLoading] = useState(true); // Estado para el spinner

  const onClose = () => {
    dispatch(uiCloseModalDelete());
    dispatch(userCleanActive());
  };

  const deleteUser = () => {
    dispatch(setDeleteUser(user));
    dispatch(uiCloseModalDelete());
    dispatch(userCleanActive());
  };

  useEffect(() => {
    setLoading(true);
    const values: IValidateUser = {
      idUser: user.id,
      idEntity: user.idEntity,
    };

    dispatch(ValdiateDeleteUser(values));
    const timer = setTimeout(() => {
      setLoading(false); // Detiene el spinner después de 5 segundos
    }, 2000); // 5000ms = 5 segundos
  }, []);

  return (
    <Box m={1} display={"flex"} flexDirection="column">
      {loading && (
        <Box style={{ textAlign: "center", margin: "1rem" }}>
          <CircularProgress />
        </Box>
      )}
      {!loading && (
        <>
          <Box>
            <label
              className="form-text"
              style={{ textAlign: "center", display: "block" }}
            >
              {DeleteValidation ? (
                <FormattedMessage id="user.messageDelete" />
              ) : (
                <FormattedMessage id="user.CanNotDelete" />
              )}
            </label>
          </Box>
          <Box>
            <br />
            <label
              className="form-text"
              style={{ textAlign: "center", display: "block" }}
            >
              {user?.firstName || ""} {user?.secondName || ""}{" "}
              {user?.firstLastName || ""} {user?.secondLastName || ""}
            </label>
          </Box>
          <Box mt={2} style={{ textAlign: "center", display: "block" }}>
            <Button
              className={clsx(classes.btn, classes.cancel)}
              onClick={onClose}
            >
              <FormattedMessage id="Cancel" />
            </Button>
            {DeleteValidation ? (
              <Button
                className={clsx(classes.btn, classes.save)}
                onClick={deleteUser}
              >
                <FormattedMessage id="Delete" />
              </Button>
            ) : (
              ""
            )}
          </Box>
        </>
      )}
    </Box>
  );
};
